module.exports = __webpack_public_path__ + "media/content-creator/fashion-1-53ec8078.png";